<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="data"
          :model="data"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <el-form-item label="区域编号" prop="RegionNo">
            <el-input v-model="data.RegionNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="区域名称" prop="RegionName">
            <el-input v-model="data.RegionName" clearable></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Remark">
            <el-input v-model="data.Remark" clearable></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button type="primary" @click="OnConfirm('data')">确认</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import MyApis from "../../apis";
import ZJApp from "../../../../app";
export default {
  name: "ZjRegionManagerInfo",
  props: {
    RegionInfo: {
      default: () => ({}),
      type: Object,
    },
    DrawRegionInfo: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      data: {
        RegionNo: "",
        RegionName: "",
        Remark: "",
        RegionId: "",
      },
      rules: {
        RegionNo: [
          { required: true, message: "请输入区域编号", trigger: "blur" },
        ],
        RegionName: [
          { required: true, message: "请输入区域名称", trigger: "blur" },
        ],
      },
    };
  },
  created: function() {
    //   this.data = this.RegionInfo;
    // alert(1);
    // this.init();
  },
  mounted: function() {
    // alert(2);
    // this.init();
    this.$nextTick(() => {
      this.init();
    });
  },
  watch: {
    RegionInfo: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        (this.data = {
          RegionNo: "",
          RegionName: "",
          Remark: "",
          RegionId: "",
        }),
          this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 初始化
    init() {
      this.data = this.RegionInfo;
    },
    OnConfirm(formName) {
      const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.GetRegions(function(data) {
            if (!data) {
              that.saveData();
            }
          });
        } else {
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    //检验是否有重复记录
    GetRegions(callback) {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      let isExistEntity = false;
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          const result = r;
          if (result != null) {
            if (this.data.RegionId != undefined && this.data.RegionId != "") {
              const index = result.findIndex(
                (p) =>
                  (p.RegionName == this.data.RegionName ||
                    p.RegionNo == this.data.RegionNo) &&
                  p.RegionId != this.data.RegionId
              );
              if (index > -1) {
                this.$message.error("区域编码或名称已存在，请重新输入！");
                isExistEntity = true;
              }
            } else {
              const index = result.findIndex(
                (p) =>
                  p.RegionName == this.data.RegionName ||
                  p.RegionNo == this.data.RegionNo
              );
              if (index > -1) {
                this.$message.error("区域编码或名称已存在，请重新输入！");
                isExistEntity = true;
              }
            }
          }
          callback(isExistEntity);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    saveData() {
      let uuid = "";
      if (this.data.RegionId != undefined && this.data.RegionId != "") {
        uuid = this.data.RegionId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      const Areas = this.DrawRegionInfo.map((item, index) => ({
        AreaIndex: index,
        Longitude: item.lng,
        Latitude: item.lat,
      }));
      if (this.data.RegionId != undefined && this.data.RegionId != "") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        this.data.Areas = Areas;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.RegionList()
          .UpdateRegion(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "修改成功！" : "修改失败！",
            });
            this.logInfo.ActionName = "区域修改";
            this.logInfo.LogMessage = "区域修改成功";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "区域管理详情";
            this.addOperationLog();
            this.$emit("clickCancel", {});
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        const formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          RegionId: uuid,
          Validity: 1, //新增编辑是1，删除是0
          Areas: Areas,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);

        new MyApis.RegionList()
          .AddRegion(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "区域添加";
            this.logInfo.LogMessage = "区域添加成功";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "区域管理详情";
            this.addOperationLog();
            this.$emit("clickCancel", {});
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>

<style></style>
